import * as React from "react";
import { Link } from "react-router-dom";

import { SimpleHorse } from "../../model/Horse";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";

export const HorseLink = ({
    horse,
    className,
    targetBlank,
    showGait,
    showAsButton,
    children
}: {
    horse: SimpleHorse;
    targetBlank?: boolean;
    showAsButton?: boolean;
    showGait?: boolean;
    className?: string;
    children?: React.ReactNode;
}) => {
    return (
        <Link
            to={`/horse/${horse.id}`}
            className={`${showAsButton ? "btn btn-info btn-sm" : ""} ${className ? className : "d-block"} `}
            target={targetBlank ? "_blank" : ""}
        >
            {horse.name}
            {showGait && horse.gait && <span className="ml-2 mr-2">({horse.gait.abbreviation})</span>}
            {children}
            {targetBlank && <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 mr-2" />}
        </Link>
    );
};



// WEBPACK FOOTER //
// ./src/components/common/HorseLink.tsx